import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Button } from '@components/Button/Button';
import { DriverCard } from '@components/DriverCard/DriverCard';
import Icon from '@components/Icon/Icon';
import { TripHeader } from '@components/TripHeader/TripHeader';
import { TripPoint } from '@components/TripPoint/TripPoint';
import { EIcons } from '@enums/icons.enum';
import { ERoutes } from '@enums/routes.enum';
import { EStyles } from '@enums/style.enum';
import { TripStatus } from '@enums/trips.enum';
import type { RootState } from '@store/store';

import classes from './TripDetailInfo.module.scss';

type Props = {
	isCollapse: boolean;
	onCollapse: () => void;
};

export const TripDetailInfo: React.FC<Props> = ({ isCollapse, onCollapse }) => {
	const stops = useSelector((state: RootState) => state.trips.currentTrip?.stops);
	const status = useSelector((state: RootState) => state.trips.currentTrip?.status);
	const driver = useSelector((state: RootState) => state.trips.currentTrip?.driver?.id);
	const trackingUrl = useSelector((state: RootState) => state.trips.currentTrip?.trackingUrl);

	const { t } = useTranslation();

	const onLocateVehicle = () => {
		window.open(trackingUrl, ERoutes.blank, ERoutes.noopener);
	};

	const onCallDispatcher = () => {
		window.location.href = `${ERoutes.tel}${import.meta.env.VITE_DISPATCHER_PHONE_NUMBER}`;
	};

	return (
		<div className={`${classes['container']} ${isCollapse ? classes['isCollapsed'] : EStyles.emptyQuote}`}>
			<button
				className={`${classes['collapseContainer']} ${isCollapse ? classes['modal-isCollapse'] : EStyles.emptyQuote}`}
				onClick={onCollapse}
			>
				<Icon name={EIcons.Back} style={{ transform: 'rotate(270deg)' }} size={16} color="var(--medium)" />
			</button>
			<TripHeader />
			<div className={classes['collapsibleWrapper']}>
				<div className={classes['innerContainer']}>
					<div className={classes['stopsContainer']}>
						{stops?.map((stop) => (
							<TripPoint
								key={stop.id}
								stopType={stop.passengers[0]?.stopType}
								locationName={stop?.address?.displayName}
								locationType={stop?.address?.type}
								date={stop?.date}
							/>
						))}
					</div>
					{driver && <DriverCard />}
				</div>
				<div className={classes['buttonsContainer']}>
					<Button primary onClick={onCallDispatcher} className={classes.actionButton} icon={EIcons.Phone} style={{ height: 46 }}>
						{t('tripDetailInfo.contactDispatcher')}
					</Button>
					<Button
						disabled={!driver || status !== TripStatus.InRoute || !trackingUrl}
						primary
						onClick={onLocateVehicle}
						className={classes.actionButton}
						icon={EIcons.LocationMark}
						style={{ height: 46 }}
					>
						{t('tripDetailInfo.locateVehicle')}
					</Button>
				</div>
			</div>
		</div>
	);
};
